 <template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="6" lg="6">
        <b-card no-body class="bg-info">
          <b-card-body>
            <h4 class="mb-0">{{ logs ? logs.length : 0 }}</h4>
            <p>Logs</p>
            <b-btn variant="primary" style="margin-bottom: 5px;" @click="clearTestData">Clear Test Data</b-btn>
            <p v-if="clearTestDataTimestamp || getOrganizationLastClearedTimestamp()">Last cleared: {{formatTimestamp(clearTestDataTimestamp)}}</p>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="6">
        <b-card no-body class="bg-info">
          <b-card-body>
            <h4 class="mb-0">Search</h4>
            <p>By User Email, Log Type, or Object ID</p>
            <b-input-group>
              <b-form-input v-model="filter.nameText" @input="handleFilterChange" placeholder="Type to Search" />
              <b-input-group-addon>
                <b-btn :disabled="!filter.nameText" @click="clearFilter">Clear</b-btn>
              </b-input-group-addon>
            </b-input-group>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12">
        <div>
          <b-btn v-b-toggle.collapse1 variant="primary">Filters</b-btn>
          <b-btn
          v-on:click.prevent="resetFilters">Clear Filters</b-btn>


          <b-collapse id="collapse1" class="mt-2">
            <b-card>
              <b-row>
                <b-col sm="3">
                  <b-form-group label="Date">
                    <datepicker
                      initial-view="year"
                      class="mb-2 mr-sm-2 mb-sm-0"
                      v-model="filter.date"
                      :style="{ width: '150px', height: '35px' }"
                      id="filter_date"
                      placeholder="Select Date"
                      :format="this.$dateFormatter"
                      :disabled-dates="{ from: new Date() }"
                      clear-button
                    >
                    </datepicker>
                    <!-- <b-form-select class="mb-2 mr-sm-2 mb-sm-0"
                      v-model="filter.date"
                      :style="{ width: '150px' }">
                      <option slot="first" :value="null">Choose...</option>
                      <option value="true">true</option>
                      <option value="false">false</option>
                    </b-form-select> -->
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label="Log Type">
                    <b-form-select class="mb-2 mr-sm-2 mb-sm-0"
                      v-model="filter.logType"
                      :style="{ width: '150px' }">
                      <option slot="first" :value="null">Choose...</option>
                      <option value="Create - Assessment">Create - Assessment</option>
                      <option value="Create - CSE-IT">Create - CSE-IT</option>
                      <option value="Create - Group">Create - Group</option>
                      <option value="Create - Location">Create - Location</option>
                      <option value="Create - Note">Create - Note</option>
                      <option value="Create - Organization">Create - Organization</option>
                      <option value="Create - Person">Create - Person</option>
                      <option value="Create - Person External ID">Create - Person External ID</option>
                      <option value="Create - Program">Create - Program</option>
                      <option value="Create - Sharing Assessment">Create - Sharing Assessment</option>
                      <option value="Create - Sharing CSE-IT">Create - Sharing CSE-IT</option>
                      <option value="Create - Sharing Note">Create - Sharing Note</option>
                      <option value="Create - Sharing Person">Create - Sharing Person</option>
                      <option value="Create - User Member">Create - User Member</option>
                      <option value="ERROR - Create User">ERROR - Create User</option>
                      <option value="ERROR - Update User Member">ERROR - Update User Member</option>
                      <option value="Login - Success">Login - Success</option>
                      <option value="Logout - Success">Logout - Success</option>
                      <option value="Update - Assessment">Update - Assessment</option>
                      <option value="Update - CSE-IT">Update - CSE-IT</option>
                      <option value="Update - Group">Update - Group</option>
                      <option value="Update - Location">Update - Location</option>
                      <option value="Update - Note">Update - Note</option>
                      <option value="Update - Organization">Update - Organization</option>
                      <option value="Update - Person">Update - Person</option>
                      <option value="Update - Person External ID">Update - Person External ID</option>
                      <option value="Update - Program">Update - Program</option>
                      <option value="Update - Sharing Assessment">Update - Sharing Assessment</option>
                      <option value="Update - Sharing CSE-IT">Update - Sharing CSE-IT</option>
                      <option value="Update - Sharing Note">Update - Sharing Note</option>
                      <option value="Update - Sharing Person">Update - Sharing Person</option>
                      <option value="Update - User Member">Update - User Member</option>
                      <option value="Update - User">Update - User</option>
                      <option value="View - Assessment">View - Assessment</option>
                      <option value="View - CSE-IT">View - CSE-IT</option>
                      <option value="View - Person">View - Person</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label="Sys Alert">
                    <b-form-select class="mb-2 mr-sm-2 mb-sm-0"
                      v-model="filter.sysAlert"
                      :style="{ width: '150px' }">
                      <option slot="first" :value="null">Choose...</option>
                      <option value="true">true</option>
                      <option value="false">false</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-collapse>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12">
        <b-card>
          <h2 v-show="!finishedLoading" class="u-padding-bottom-20">Loading, please wait ...</h2>
          <pulse-loader :loading="!finishedLoading" :color="spinnerColor" :size="spinnerSize"></pulse-loader>
          <b-table
              v-show="finishedLoading"
              :filter="filter"
              :filter-function="searchFilter"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              @filtered="onFiltered" :hover="true"
              :striped="true"
              :bordered="false"
              :small="true"
              :fixed="true"
              responsive="sm"
              :items="logs"
              :fields="getTableFields()"
              :per-page="20"
              :current-page="currentPage">
              <div slot="logDTS" class="" slot-scope="item">
                <span>{{formatTimestamp(item.value)}}</span>
              </div>
              <div slot="objectID" class="" slot-scope="item">
                <b-link @click="goObject(item.value)"><span class="">{{item.value}}</span></b-link>
              </div>
              <div slot="payload" class="" slot-scope="item">
                <b-button size="sm" @click="item.toggleDetails" class="">
                    {{ item.detailsShowing ? 'Hide' : 'Show' }}
                </b-button>
              </div>
              <div slot="row-details" class="" slot-scope="data">
                <b-card>
                    {{data.item.payload}}
                </b-card>
              </div>
          </b-table>
          <b-pagination :total-rows="getRowCount(logs)" prev-text="Prev" next-text="Next" :current-page="currentPage" v-model="currentPage"></b-pagination>
        </b-card>
      </b-col>
    </b-row>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'logs',
  computed: {
    ...mapGetters({
      userCurrentContext: 'userCurrentContext',
      logs: 'getLogs'
    })
  },
  watch: {
    userCurrentContext: function (newValue) {
      if (newValue) {
        this.searchLogs()
      }
    }
  },
  data: function () {
    return {
      spinnerColor: '#489AAC',
      spinnerSize: '50px',
      finishedLoading: false,
      selected: 'Month',
      currentPage: 1,
      filter: {
        date: null,
        logType: null,
        sysAlert: null,
        nameText: sessionStorage.getItem('logSearchFilter') || ''
      },
      showDataTable: false,
      clearTestDataTimestamp: '',
      clearTestDataMessage: '',

      // Fields for the Data Table
      supportBackup: true,
      supportNested: true,
      query: { limit: 10 },
      data: [],
      total: 0,
      Pagination: true,

      // Fields for the bootstrap table
      sortBy: 'logDTS',
      sortDesc: true,
      sortDirection: 'desc',
      tableFields: {
        logDTS: {
          label: 'Log DTS',
          sortable: true
        },
        userID: {
          label: 'User ID',
          sortable: true
        },
        userEmail: {
          label: 'User Email',
          sortable: true
        },
        logType: {
          label: 'Log Type',
          sortable: true
        },
        objectID: {
          label: 'Object ID',
          sortable: true
        },
        sysAlert: {
          label: 'Sys Alert',
          sortable: true
        },
        payload: {
          label: 'Payload',
          sortable: false
        }
      }
    }
  },
  created: function () {
    this.searchLogs()
  },
  methods: {
    clearTestData () {
      var params
      const env = process.env.NODE_ENV
      if (env !== 'production') {
        params = {
          orgId: 37
        }
      } else {
        params = {
          orgId: 1
        }
      }
      this.$store.dispatch('clearTestData', params).then(res => {
        if (res.success) {
          this.clearTestDataTimestamp = res.message
        } else {
          this.clearTestDataMessage = res.message
        }
      })
    },
    getOrganizationLastClearedTimestamp () {
      const env = process.env.NODE_ENV
      let testOrgId
      if (env !== 'production') {
        testOrgId = 37
      } else {
        testOrgId = 1
      }
      this.$store.dispatch('getOrganizations', { id: testOrgId }).then((res) => {
        const testOrg = res.filter(({id}) => id === testOrgId)[0]
        if (testOrg && testOrg.lastClearedTestData) {
          this.clearTestDataTimestamp = testOrg.lastClearedTestData
          return this.clearTestDataTimestamp
        }
        return ''
      })
    },
    searchLogs () {
      var params = {
        sort: 'logDTS DESC'
      }

      this.$store.dispatch('getLogs', params).then(response => {
        this.finishedLoading = true
        console.log(response)
      })
    },
    searchFilter (originalRecord) {
      let foundMatch = false
      let foundDate = true
      let foundLogType = true
      let foundSysAlert = true

      const stringSearches = [ 'logDTS', 'userID', 'userEmail', 'logType', 'objectID', 'sysAlert' ]
      if (this.filter.date !== null) {
        foundDate = Math.round((Date.parse(this.filter.date) / (60 * 60 * 24 * 1000))) === Math.round((originalRecord['logDTS'] / (60 * 60 * 24)))
      }

      if (this.filter.logType !== null) {
        foundLogType = this.filter.logType === originalRecord['logType']
      }

      if (this.filter.sysAlert !== null) {
        foundSysAlert = this.filter.sysAlert === (originalRecord['sysAlert'] ? 'true' : 'false')
      }

      if (this.filter.nameText === null) {
        return foundDate && foundLogType && foundSysAlert
      }

      let filter = this.filter.nameText.toLowerCase()

      _.forEach(stringSearches, element => {
        if (element === 'primaryOrganization') {
          let field = originalRecord[element].title
          if (_.isString(field) && field !== '') {
            field = field.toLowerCase()
            if (originalRecord[element].title.toLowerCase().indexOf(filter) >= 0) {
              foundMatch = true
            }
          }
        } else {
          let field = originalRecord[element]
          if (_.isString(field) && field !== '') {
            field = field.toLowerCase()
            if (originalRecord[element].toLowerCase().indexOf(filter) >= 0) {
              foundMatch = true
            }
          }
        }
      })

      return foundMatch && foundDate && foundLogType && foundSysAlert
    },
    resetFilters () {
      this.filter.date = null
      this.filter.logType = null
      this.filter.sysAlert = null
    },
    // searchFilter (originalRecord) {
    //   let foundMatch = false
    //   const stringSearches = [ 'logDTS', 'userID', 'userEmail', 'logType', 'objectID', 'sysAlert' ]

    //   if (this.filter === null) {
    //     return true
    //   }

    //   let filter = this.filter.toLowerCase()

    //   _.forEach(stringSearches, element => {
    //     let field = originalRecord[element]

    //     if (_.isString(field) && field !== '') {
    //       field = field.toLowerCase()
    //       if (originalRecord[element].toLowerCase().indexOf(filter) >= 0) {
    //         foundMatch = true
    //       }
    //     }
    //   })

    //   return foundMatch
    // },
    getTableFields () {
      var fields = this.tableFields

      if (!this.$auth.user().isSuperAdmin) {
        delete fields.organization
      }

      return this.tableFields
    },
    goObject (item) {
      if (item[0] === 'P') {
        const path = '/person/' + item
        this.$router.push({ path: path })
      } else if (item[0] === 'A') {
        const path = '/screening/' + item
        this.$router.push({ path: path })
      }
    },
    variant (value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    },
    flag (value) {
      return 'flag-icon flag-icon-' + value
    },
    getRowCount (items) {
      return items.length
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    formatTimestamp: function (value) {
      return this.$utils.unixToHuman(value)
    },
    handleFilterChange (value) {
      sessionStorage.setItem('logSearchFilter', value)
    },
    clearFilter (value) {
      this.filter.nameText = ''
      sessionStorage.setItem('logSearchFilter', '')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/t1/Admin/Logs.vue